import { useMemo } from "react";
import { Grid, Box, Typography, Skeleton } from "@mui/material";
import ArchiveIcon from "@mui/icons-material/Archive";
import { DocumentCard } from "../documentCRUD/DocumentCard";
import { useTheme } from "@mui/material/styles";

export const DocumentList = ({ documents, searchQuery, onOpenUpdateModal, onOpenDesactiveModal, loading, token, isInactiveView }) => {
  const theme = useTheme();

  const filteredDocuments = useMemo(() => {
    if (!searchQuery) return documents;
    const lowerQuery = searchQuery.toLowerCase();
    return documents.filter((doc) => {
      const nameMatch = doc.NOMBRE_DOCUMENTO?.toLowerCase().includes(lowerQuery);
      return nameMatch;
    });
  }, [documents, searchQuery]);

  if (loading) {
    return (
      <Grid container spacing={3}>
        {Array.from({ length: 6 }).map((_, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Skeleton
              variant="rectangular"
              height={160}
              sx={{ borderRadius: "12px", width: "100%" }}
            />
          </Grid>
        ))}
      </Grid>
    );
  }

  if (!documents || documents.length === 0) {
    return (
      <EmptyState
        theme={theme}
        title="No hay documentos"
        description="Aún no se ha creado ningún documento."
      />
    );
  }

  if (filteredDocuments.length === 0) {
    return (
      <EmptyState
        theme={theme}
        title="Sin resultados"
        description={`No se encontraron documentos para "${searchQuery}".`}
      />
    );
  }

  return (
    <Grid container spacing={3}>
      {filteredDocuments.map((doc) => (
        <Grid item xs={12} sm={6} md={4} key={doc.ID_DOCUMENTO}>
          <DocumentCard
            documents={doc}
            onOpenUpdateModal={onOpenUpdateModal}
            onOpenDesactiveModal={onOpenDesactiveModal}
            isInactiveView={isInactiveView}
          />
        </Grid>
      ))}
    </Grid>
  );
};

const EmptyState = ({ theme, title, description }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    py={8}
    px={2}
    textAlign="center"
  >
    <Box
      sx={{
        width: 80,
        height: 80,
        borderRadius: "50%",
        backgroundColor: theme.palette.background.default,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 2,
        color: theme.palette.text.secondary,
        border: `1px dashed ${theme.palette.divider}`,
      }}
    >
      <ArchiveIcon fontSize="large" />
    </Box>
    <Typography variant="h6" color="text.primary" gutterBottom sx={{ fontWeight: 600 }}>
      {title}
    </Typography>
    <Typography variant="body2" color="text.secondary">
      {description}
    </Typography>
  </Box>
);
